<script>
import animation from '../partials/components/animate.vue';

export default {
    components: { animation }
};
</script>
